import { useContext } from "react";
import { useSearchParams } from "react-router-dom";
import CrudContext from "../context/crudContext";
import FilterContext from "../context/filterContext";
import style from "../styles/administrator.module.css";

const FilterSearch = () => {
  const { filter, handleFilter, handleCategory, todosLosProducts } =
    useContext(FilterContext);
  const { db } = useContext(CrudContext);

  const reduceCategories = () => {
    let categories = [];
    db.Product && db.Product.filter((el) => categories.push(el.pro_category));

    let newFilter = [...new Set(categories)];
    return newFilter;
  };

  return (
    <div className={style.inventoryMenu}>
      <div className={style.inventorycontainer}>
        <div className={style.inventorySearch}>
          <p className={style.title}>Inventario</p>
          <input
            className={style.inputSearch}
            type="search"
            name="filter"
            id="filter"
            placeholder="Buscar por nombre..."
            onChange={handleFilter}
            value={filter}
          />
        </div>
        <div className={style.addContainer}>
          <div className="dropdown">
            <button
              className="btn btn-secondary dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span>Filtrar por </span>
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <p className="dropdown-item">
                <strong
                  style={{ cursor: "pointer" }}
                  onClick={todosLosProducts}
                >
                  Todos los productos
                </strong>
              </p>
              {reduceCategories().map((el, i) => (
                <p
                  onClick={handleCategory}
                  key={i}
                  className="dropdown-item"
                  style={{ cursor: "pointer" }}
                >
                  {el}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSearch;
